import { render, staticRenderFns } from "./CustomerProjectsComponent.vue?vue&type=template&id=bdf38ba2&"
import script from "./CustomerProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProjectsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports